import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

type GamificationTabKey = 'missions' | 'rewards';

export interface GamificationTabConfig<Value extends string> {
  key: GamificationTabKey;
  value: Value;
}

// Pass a module-level `tabs` constant so the memo is recomputed only when translations or the rewards count change.
export const useGamificationTabs = <Value extends string>(
  tabs: readonly GamificationTabConfig<Value>[],
  totalRewards?: number,
) => {
  const t = useTranslations('gamification');

  return useMemo(() => tabs.map(({ key, value }) => ({
    value,
    title: t(key),
    badge: key === 'rewards' && totalRewards ? totalRewards : null,
  })), [t, tabs, totalRewards]);
};
